<template>
    <div>
        <van-cell @click="openUserProfile" is-link>
            <template #title>
                <div class="title">
                    <van-image
                            round
                            width="20px"
                            height="20px"
                            fit="cover"
                            :src="ExternalUser.Avatar"
                    />
                    {{ ExternalUser.Name }}
                </div>
            </template>
            <template>
                {{ ExternalUser.CreateDate }}
            </template>
        </van-cell>
        <van-field v-model="ExternalUser.StatusMemo" @click="actionSheet.show=true" readonly label="跟进状态" is-link/>
        <van-field @click="actionSheetSOP.show=true" readonly label="自动跟进" is-link>
            <template #input>
                <div>
                    <span v-if="ExternalUser.Pause == 0 ">开启</span>
                    <span v-else>暂停-{{ ExternalUser.PauseDate }}</span>
                </div>
            </template>
        </van-field>

        <van-field type="number" v-model="ExternalUser.ExpectAmount" @change="closeKeyboard" is-link
                   label="预计成交"/>
        <van-field v-model="ExternalUser.IndustryDesc" @click="actionSheetIndustry.show=true" readonly label="行业"
                   is-link/>
        <van-field v-for="(item,index) in ExternalUser.$3" v-model="item.Mobile" @click="openUserProfile" readonly
                   :label="'手机'+(index+1)" is-link/>
        <van-field v-for="(item,index) in ExternalUser.$1" v-model="item.CPName +' '+ item.CreateDate"  readonly
                   :label="'跟进人'+(index+1)">
        </van-field>

        <van-tabs v-model="active" animated sticky>
            <van-tab title="跟进记录">
                <div style="display: flex;align-items: center;justify-content: center;padding: 16px">
                    <van-button type="primary" @click="addMemo">填写跟进记录</van-button>
                </div>
                <template v-for="item in ExternalUser.$2">
                    <van-cell>
                        <template #title>
                            <div class="title">
                                <van-image
                                        round
                                        width="20px"
                                        height="20px"
                                        fit="cover"
                                        :src="item.CPAvatar"
                                />
                                {{ item.CPName }}
                            </div>
                        </template>
                        <template>
                            {{ item.CreateDate }}
                        </template>
                    </van-cell>
                    <div class="status_memo">{{ item.Memo }}</div>
                </template>

            </van-tab>
            <van-tab title="预约回访">
                <div style="display: flex;align-items: center;justify-content: center;padding: 16px">
                    <van-button type="primary" @click="addReserv">添加预约回访</van-button>
                </div>
                <template v-for="item in ExternalUser.$5">
                    <van-cell>
                        <template #title>
                            <div class="title">
                                <van-image
                                        round
                                        width="20px"
                                        height="20px"
                                        fit="cover"
                                        :src="item.CPAvatar"
                                />
                                {{ item.CPName }}
                            </div>
                        </template>
                        <template>
                            <van-icon @click="removeReserv(item)" name="delete-o" v-if="item.HasRemove==1"/>
                            {{ item.ReservDate }}
                        </template>
                    </van-cell>
                    <div class="status_memo">{{ item.Memo }}</div>
                </template>

            </van-tab>

            <van-tab title="素材">
                <div class="follow_list_item" v-for="item in ExternalUser.$4">
                    <van-cell>
                        <template #title>
                            <div class="title">
                                <van-image
                                        round
                                        width="20px"
                                        height="20px"
                                        fit="cover"
                                        :src="item.CPAvatar"
                                />
                                {{ item.CPName }}
                            </div>
                        </template>
                        <template>
                            {{ item.CreateDate }}
                        </template>
                    </van-cell>
                    <div>
                        <div class="resource" v-if="item.ResourceType == 'text'">{{ item.Resource }}</div>
                        <div class="resource" v-if="item.ResourceType == 'image'">
                            <van-image @click="previewImage(item)"
                                       width="60"
                                       height="60"
                                       :src="item.Resource"
                            />
                            <div style="padding-left: 12px">图片</div>
                        </div>
                        <div class="resource" v-if="item.ResourceType == 'video'">
                            <van-image
                                    width="60"
                                    height="60"
                                    :src="item.Resource"
                            />
                            <div style="padding-left: 12px">视频</div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="跟进人">
                <template v-for="item in ExternalUser.$1">
                    <div class="follow_list_item">
                        <van-cell>
                            <template #title>
                                <div class="title">
                                    <van-image
                                            round
                                            width="20px"
                                            height="20px"
                                            fit="cover"
                                            :src="item.CPAvatar"
                                    />
                                    {{ item.CPName }}
                                </div>
                            </template>
                            <template>
                                {{ item.CreateDate }}
                            </template>
                        </van-cell>
                        <van-field v-model="item.StatusMemo" label="跟进状态" placeholder="请输入用户名" readonly/>
                        <van-field v-model="item.ExpectAmount" label="预计成交" placeholder="请输入用户名" readonly/>
                    </div>
                </template>

            </van-tab>

        </van-tabs>

        <van-action-sheet
                description="跟进状态"
                v-model="actionSheet.show"
                :actions="actionSheet.actions"
                cancel-text="取消"
                close-on-click-action
                @select="onSelectActionSheet"
        />

        <van-action-sheet
                description="自动跟进"
                v-model="actionSheetSOP.show"
                :actions="actionSheetSOP.actions"
                cancel-text="取消"
                close-on-click-action
                @select="onSelectActionSheetSOP"
        />

        <van-action-sheet
                description="行业"
                v-model="actionSheetIndustry.show"
                :actions="actionSheetIndustry.actions"
                cancel-text="取消"
                close-on-click-action
                @select="onSelectActionSheetIndustry"
        />
    </div>
</template>
<script>

export default {
    components: {},
    data() {
        return {
            ExternalUserId: "", ExternalUser: {ExpectAmount: ""}, active: 0,
            actionSheetIndustry: {
                show: false,
                actions: []
            },
            actionSheet: {
                show: false,
                actions: [
                    {name: '未知行业', value: 50, subname: '已填写行业的，跟进状态不要选择[未知行业]'},
                    {name: '未跟进', value: 100},
                    {name: '需求确认', value: 200},
                    {name: '未演示、试用中', value: 300},
                    {name: '已演示、试用中', value: 400},
                    {name: '已演示、未试用', value: 500},
                    {name: '已成交', value: 600}
                ]
            },
            actionSheetSOP: {
                show: false,
                actions: [
                    {name: '启用', value: 0},
                    {name: '暂停(只用于人工介入时才暂停，成交后也会推送促成二次成交活动的文案)', value: 1},
                ]
            },
            keyboard: {
                show: false,

            }
        }
    },
    created() {
        const route = this.$route;
        this.ExternalUserId = route.query.ExternalUserId
        this.get_data()
        this.getWXIndustry()
    },
    methods: {
        async removeReserv(item) {
            await this.$dialog.confirm({
                title: "温馨提示",
                message: '是否删除当前预约？',
            });
            await this.$frame.postBusiness("WXExternalUserFollowReserv", {
                PaperNO: item.PaperNO,
                UpdateFlag: 'D'
            })
            this.get_data()
        },
        previewImage(item) {
            vant.ImagePreview({images: [item.Resource], closeable: true});
        },
        openUserProfile() {
            wx.invoke('openUserProfile', {
                "type": 2, //1表示该userid是企业成员，2表示该userid是外部联系人
                "userid": this.ExternalUserId //可以是企业成员，也可以是外部联系人
            }, function (res) {
                if (res.err_msg != "openUserProfile:ok") {
                    //错误处理
                }
            });
        },
        async onSelectActionSheetSOP(item) {
            await this.$dialog.confirm({
                title: "温馨提示",
                message: '是否修改自动跟进状态？',
            });

            await this.$frame.postBusiness("WXExternalUserSOPPause", {
                ExternalUserId: this.ExternalUserId,
                Pause: item.value
            })
            this.get_data()
        },
        async onSelectActionSheetIndustry(item) {
            await this.$dialog.confirm({
                title: "温馨提示",
                message: '是否修改行业？',
            });

            if (item.name == "未知行业") {
                await this.$dialog.confirm({
                    title: "温馨提示",
                    message: '当前选择行业为[未知行业],跟进状态也会自动改变为[未知行业]，是否继续修改？',
                });
            }

            await this.$frame.postBusiness("WXExternalUserIndustry", {
                ExternalUserId: this.ExternalUserId,
                IndustryNO: item.IndustryNO
            })
            this.get_data()
        },
        async onSelectActionSheet(item) {
            await this.$dialog.confirm({
                title: "温馨提示",
                message: '是否修改跟进状态？',
            });

            if (item.name == "未知行业") {
                await this.$dialog.confirm({
                    title: "温馨提示",
                    message: '当前选择跟进状态为[未知行业],行业也会自动改变为[未知行业]，是否继续修改？',
                });
            }

            await this.$frame.postBusiness("WXExternalUserFollowStatus", {
                ExternalUserId: this.ExternalUserId,
                Status: item.value
            })
            this.get_data()
        },
        blurKeyboard() {
            this.ExternalUser.ExpectAmount = this.ExternalUser.ExpectAmount_clone
            this.keyboard.show = false
        },
        async closeKeyboard() {
            if (!this.ExternalUser.ExpectAmount || this.ExternalUser.ExpectAmount == "0") {
                vant.Toast('请输入预计成交金额');
                return
            }
            let _amount = this.ExternalUser.ExpectAmount
            await this.$dialog.confirm({
                title: "温馨提示",
                message: '是否保存预计成交金额？',
            });
            this.ExternalUser.ExpectAmount = _amount
            await this.$frame.postBusiness("WXExternalUserFollowExpectAmount", {
                ExpectAmount: _amount,
                ExternalUserId: this.ExternalUserId
            })
            this.get_data()
        },
        addReserv() {
            this.$router.push({
                path: "/work/addReserv",
                query: {
                    ExternalUserId: this.ExternalUserId
                }
            });
        },
        addMemo(item) {
            this.$router.push({
                path: "/work/addMemo",
                query: {
                    ExternalUserId: this.ExternalUserId
                }
            });
        },
        async get_data() {
            this.ExternalUser = await this.$frame.getDataObjectData("ExternalUser", {ExternalUserId: this.ExternalUserId})
            this.ExternalUser.ExpectAmount_clone = this.ExternalUser.ExpectAmount
        },
        async getWXIndustry() {
            let _data = await this.$frame.getStdQueryData("WXIndustry")
            this.actionSheetIndustry.actions = []
            for (let i = 0; i < _data.StdQuery.length; i++) {
                this.actionSheetIndustry.actions.push({
                    name: _data.StdQuery[i].IndustryDesc,
                    IndustryNO: _data.StdQuery[i].IndustryNO,
                    subname: _data.StdQuery[i].IndustryDesc == '未知行业' ? '选行未知行业的,跟进状态也需要选择为未知行业' : ""
                })
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  ::v-deep {
    .van-image {
      margin-right: 12px;
    }
  }
}

.status_memo {
  background-color: #fff;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: $base-box-shadow;
}

.follow_list_item {
  margin-bottom: 12px;
  box-shadow: $base-box-shadow;
}

.resource {
  display: flex;
  align-items: center;
  font-size: 10px;
  background-color: #fff;
  padding: 16px;
}
</style>
